module.exports = __webpack_public_path__ + "static/media/logo1024x1024.2cbc476d.png";